/*
 * @Author: Jon Lucas
 * @Date: 2017-10-18 15:42:43
 * @Last Modified by: Jon Lucas
 * @Last Modified time: 2017-12-22 12:48:26
 */


import { Component, OnInit, ElementRef, AfterViewInit } from "@angular/core";

import { AbstractViewComponent } from "../abstract-view/abstract-view.component";

import { BaseDataType } from "../../base-data-type";

import { ConfDataType } from "../../conf-data-type";
import { AppService } from "../../app.service";
import { ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import { Http, RequestOptions, Headers } from "@angular/http";
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { LabelType } from "../../label-type";
import { Utils } from "../../util/Utils";
import { LoaderUtils } from "../../util/LoaderUtils";
import {ApiUtils} from "../../util/ApiUtils";

@Component({
    selector: "app-contact-form",
    templateUrl: "./contact-form.component.html",
    styleUrls: ["./contact-form.component.scss"]
})
export class ContactFormComponent extends AbstractViewComponent implements AfterViewInit {

    public readonly TAG: string = "[ContactFormComponent]";

    public contactFormType: BaseDataType;
    public surelevationType: BaseDataType;

    private inputFieldMessages: { [key: string]: LabelType };

    protected api_configurateur_url = environment.api_configurateur_url;
    protected configurateur_url = environment.configurateur_url;
    public grand_compte = environment.grandCompte;
    public show_search_magasin = environment.show_search_magasin;
    public already_user_url = environment.already_user_url;

    protected dataRemote;
    protected dataRemoteEnterprise;
    protected dataRemoteDepartement;
    protected dataRemoteMagasin = [];
    protected model: any = {};

    public headers = new Headers({
        "Content-Type": "application/json"
    });

    protected mappingCapadresse: { [key: string]: string } = {
        "sCQA": "capadresse_field_scqa", // Code qualité email
        "sL1_NOMEN": "raison_sociale", // Société
        "sSIREN": "siret", // Siret
        "sENSEIGNE": "name_enseigne", // Nom enseigne
        "sAPET700": "code_ape_ets", // Code ape etab
        "sLIBACTIVSOC": "libelle_ape_ets", // Libellé ape etab
        "sAPEN700": "code_ape_ent", // Code ape entre
        "sLIBACTIV": "libelle_ape_ent", // libellé ape entre
        "sDCRET": "created_date_ets", // Date de création
        "sTEFET": "effectif_ets", // Effectif etab
        "sTEFEN": "effectif_ent", // Effectif entre
        "sLIBERET": "type_societe", // Type de société
        "sCa1": "chiffres_affaire", // CA
        "sL3_CADR": "address_principal_1", // Adresse 1
        "sL4_VOIE": "address_principal_2", // Adresse 2
        "sCODPOS": "address_principal_postcode", // Code postal
        "sLIBCOM": "address_principal_city", // Ville
        "sL7_ETRG": "address_principal_country" // Pays
    };

    public resultsPostcode = [];
    public searchActivePostcode = false;
    public displayDropdownPostcode = false;
    public selectRowPostcode = null;

    public submitCheck = false;
    public isAutocompleteEvent = false;

    /**
     * Main form data dictionary.
     */
    public valuesDictionary: { [key: string]: number | string } = {};

    constructor(protected route: ActivatedRoute, private completerService: CompleterService, protected http: Http, private el: ElementRef, private apiUtils: ApiUtils) {
        super(route);

        this.completerService = completerService;

        this.dataRemoteDepartement = this.completerService.remote(this.api_configurateur_url + "/api/departements?query=", null, "departement");
        this.dataRemoteDepartement.dataField("list");
    }

    /**
     * Values are saved in confDataService.
     *
     * @param pId {string}
     */
    onKey(pId: string): void {
        console.log(this.TAG, pId);

        this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);
    }

    onKeyAutocompletePostCode(event) {
        if([13, 37, 38, 39, 40].indexOf(event.keyCode) != -1) {
            this.isAutocompleteEvent = true;
            event.stopPropagation();
            return false;
        }
        this.selectRowPostcode = 0;
        this.displayDropdownPostcode = true;
        this.searchActivePostcode = true;
        this.valuesDictionary["search_postcode"] = event.target.value;
        this.http.get(this.api_configurateur_url + "/api/capadresse?locality=" + event.target.value)
            .map(res => res.json())
            .subscribe(
                data => {
                    this.resultsPostcode = [];
                    let capadresse = data.Hp;
                    if(capadresse !== undefined) {
                        this.searchActivePostcode = false;
                        capadresse.forEach(location => {
                            let result = location.sCp + " " + location.sLoc;

                            if(location.sLieuDit != "") {
                                result += " (" + location.sLieuDit + ")";
                            }

                            if(this.resultsPostcode.indexOf(result) == -1) {
                                this.resultsPostcode.push(result);
                            }
                        })
                    } else {

                    }
                }
            )
        ;

        this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);
    }

    onKeydownPostCode(event) {
        if(event.keyCode == 13 && this.selectRowPostcode != null) {
            if(this.resultsPostcode[this.selectRowPostcode] !== undefined) {
                this.valuesDictionary["search_postcode"] = this.resultsPostcode[this.selectRowPostcode];
            }
            this.selectRowPostcode = null;
            this.displayDropdownPostcode = false;
            this.isAutocompleteEvent = true;
        }

        // 38 - Top
        if(event.keyCode == 38) {
            if(this.selectRowPostcode == null || this.selectRowPostcode == 0) {
                this.selectRowPostcode = 0;
            } else {
                --this.selectRowPostcode;
            }

            this.valuesDictionary["search_postcode"] = this.resultsPostcode[this.selectRowPostcode];
            console.log(this.resultsPostcode[this.selectRowPostcode]);
        }

        // 40 - Down
        if(event.keyCode == 40) {
            if(this.selectRowPostcode == null) {
                this.selectRowPostcode = 0;
            } else if(this.selectRowPostcode == this.resultsPostcode.length -1) {
                // Do Nothing
            } else {
                ++this.selectRowPostcode;
            }

            this.valuesDictionary["search_postcode"] = this.resultsPostcode[this.selectRowPostcode];
        }

        this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);
    }

    onFocusPostCode(event) {
        this.selectRowPostcode = 0;
    }

    onFocusOutPostCode(event) {
        this.selectRowPostcode = null;
        this.displayDropdownPostcode = false;
    }

    onPostCodeAutocompleteSelected(result): void {
        this.selectRowPostcode = null;
        this.valuesDictionary["search_postcode"] = result;
        this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);
    }

    /**
     * Values are saved in confDataService.
     *
     * @param pId {string}
     */
    onKeyAutocomplete(event, pId: string) {
        console.log(this.TAG, pId);

        this.dataRemoteEnterprise = this.completerService.remote(this.api_configurateur_url + "/api/capadresse?locality=" + this.valuesDictionary["search_postcode"] + "&societe=", "sL1_NOMEN", "sL1_NOMEN");
        this.dataRemoteEnterprise.dataField("Soc");

        this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);
    }

    onKeydown(event) {
        if(event.keyCode == 13) {
            this.isAutocompleteEvent = true;
        }
    }

    /**
     * Values are saved in confDataService.
     *
     * @param pId {string}
     */
    onBlurAutocomplete(pId: string): void {
        console.log(this.TAG, pId);

        this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);
    }

    onEnterpriseAutocompleteSelected(event): void {
        if (!event.originalObject.sSIREN) {
            return;
        }
        const siret: string = event.originalObject.sSIREN + event.originalObject.sNIC;
        this.getCompanyInformation(siret);
    }

    /**
     * Values are saved in confDataService.
     *
     * @param pId {string}
     */
    onChange(pId: string): void {
        console.log(this.TAG, pId);

        // // change option require other_category
        // if(pId === "categorie_pro") {
        //     if(this.valuesDictionary[pId] == "AUTRE") {
        //         this.types[1].options[0].required = true;
        //     } else {
        //         this.types[1].options[0].required = false;
        //     }
        // }

        if(pId == "search_magasin") {
            this.valuesDictionary["search_magasin_id"] = this.valuesDictionary[pId];
        }

        this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);
    }

    onDepartementSelect(selected, pId): void {
        console.log("item select : " + pId);
        if (selected) {
            this.valuesDictionary[pId] = selected.originalObject.id;
            this.confDataService.updateElementValues("contact-form", [this.valuesDictionary]);

            this.getMagasins(selected.originalObject.id);
        }
    }

    private getMagasins(departementId) {
        const magasinsUrl = this.api_configurateur_url + "/api/magasins/" + departementId;
        this.http.get(magasinsUrl)
            .map(res => res.json())
            .subscribe(
                data => {
                    this.dataRemoteMagasin = data.list;
                }
            );
    }

    /**
     * Get current
     *
     * @param pId
     */
    private getFields(pId: string): void {

        console.log(this.TAG, "getFields()", pId);

        const confData: ConfDataType = this.confDataService.confdata[pId];

        if (!confData || !confData.values || confData.values.length === 0) {
            this.contactFormType = undefined;
            return;
        }

        this.appService.getType(AppService.CONTACT_FORM_URL, confData.values[0])
            .then(type => {
                this.contactFormType = type;
                console.log(this.TAG, "contactFormType", this.contactFormType);
            })
            .catch(this.handleError.bind(this));

        const contactData: any[] = this.confDataService.getElementValues("contact-form");

        this.valuesDictionary = contactData && contactData.length > 0 ? contactData[0] : {};
    }

    private handleError(error: any): void {
        console.error(this.TAG, "An error occurred", error);
    }

    public getData(): void {
        super.getData();
        this.appService.getData(AppService.CONTACT_FORM_URL).then(types => {
            // if(this.valuesDictionary["categorie_pro"] !== "AUTRE") {
            //     types[2].options[0].required = false;
            // }
            this.types = types
        });
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.appService.getInputFieldMessagesTypes()
            .then(types => this.inputFieldMessages = types);

        // Force values update
        this.getFields("contact-form");
        
        if(this.valuesDictionary["search_magasin"] && this.valuesDictionary["search_departement_id"]) {
            this.getMagasins(this.valuesDictionary["search_departement_id"]);
        }
    }

    public onSubmit(e: NgForm) : void
    {
        if(!this.isAutocompleteEvent) {
            console.log(this.TAG, "onSubmit()", e);
            if (e.valid)
            {
                // Check if roof and surelevation forms are valid
                let commands: string[];
                let values: any[] = this.confDataService.getElementValues("roof-dimensions-valid");
                if (!values || values.length === 0 || values[0] !== "true")
                {
                    // Roof dimensions form invalid
                    commands = ["/lang", this.lang, "building", "roof-dimensions"];
                    this.router.navigate(commands);
                    return;
                }
                values = this.confDataService.getElementValues("surelevation-type");
                if (values && values.length > 0 && values[0] !== "no-surelevation")
                {
                    values = this.confDataService.getElementValues("surelevation-dimensions-valid");
                    if (!values || values.length === 0 || values[0] !== "true")
                    {
                        // Surelevation dimensions form invalid
                        commands = ["/lang", this.lang, "building", "surelevation-dimensions"];
                        this.router.navigate(commands);
                        return;
                    }
                }
                // Check if belriv dimensions valid
                values = this.confDataService.getElementValues("project-type");
                if (values && values.length > 0 && values[0] !== "projet-goutiere")
                {
                    // Check belriv choose
                    values = this.confDataService.getElementValues("belriv-type");
                    if (!values || values.length === 0) {
                        // Belriv type form invalid
                        commands = ["/lang", this.lang, "project", "belriv-type"];
                        this.router.navigate(commands);
                        return;
                    }

                    values = this.confDataService.getElementValues("belriv-dimensions-valid");
                    if (!values || values.length === 0 || values[0] !== "true")
                    {
                        // Belriv dimensions form invalid
                        commands = ["/lang", this.lang, "installation-and-accessories", "belriv-dimensions"];
                        this.router.navigate(commands);
                        return;
                    }

                    // Check profile muraux
                    values = this.confDataService.getElementValues("wall-profile-type");
                    if (!values || values.length === 0) {
                        // Belriv type form invalid
                        commands = ["/lang", this.lang, "installation-and-accessories", "wall-profile-type"];
                        this.router.navigate(commands);
                        return;
                    }

                    // Check installation-type == pose perpendiculaire || pose incliné
                    values = this.confDataService.getElementValues("installation-type");
                    if (!values || values.length === 0 || (values[0] !== "pose_horizontale" && values[0] !== "pose_inclinee")) {
                        // Belriv type form invalid
                        commands = ["/lang", this.lang, "installation-and-accessories", "installation-type"];
                        this.router.navigate(commands);
                        return;
                    }
                }

                // Check if gouttiere dimensions valid
                values = this.confDataService.getElementValues("project-type");
                if (values && values.length > 0 && values[0] !== "projet-debord") {
                    // Check profile choose
                    values = this.confDataService.getElementValues("profile-type");
                    if (!values || values.length === 0) {
                        // profile type form invalid
                        commands = ["/lang", this.lang, "project", "profile-type"];
                        this.router.navigate(commands);
                        return;
                    }
                    // Check descente choose
                    values = this.confDataService.getElementValues("descente-type");
                    if (!values || values.length === 0) {
                        // descente type form invalid
                        commands = ["/lang", this.lang, "project", "descente-type"];
                        this.router.navigate(commands);
                        return;
                    }
                }

                values = this.confDataService.getElementValues("project-type");
                if (values && values.length > 0 && values[0] === "projet-goutiere") {
                    // Check installation-type == pose perpendiculaire || pose incliné
                    values = this.confDataService.getElementValues("installation-type");
                    if (!values || values.length === 0 || values[0] === "pose_horizontale" || values[0] === "pose_inclinee") {
                        // Belriv type form invalid
                        commands = ["/lang", this.lang, "installation-and-accessories", "installation-type"];
                        this.router.navigate(commands);
                        return;
                    }

                    //crochet-type
                    values = this.confDataService.getElementValues("crochet-type");
                    const options = this.confDataService.getElementOptions("crochet-type");
                    let valuesInstallation = this.confDataService.getElementValues("installation-type");
                    if (
                        ((!values || values.length === 0) && valuesInstallation[0] !== "pose_sur_bandeau") || 
                        (values && values.length > 0 && values[0] === "hampe_galvanisee" && options === undefined)
                    ) {
                        // Belriv type form invalid
                        commands = ["/lang", this.lang, "installation-and-accessories", "crochet-type"];
                        this.router.navigate(commands);
                        return;
                    }
                }

                // Valid capadresse
                let contactForm = this.confDataService.getElementValues("contact-form");
                if(!this.submitCheck && contactForm[0].hasOwnProperty("raison_sociale")) {
                    this.http.get(this.api_configurateur_url + "/api/capadresse?validity=check")
                        .map(res => res.json())
                        .subscribe(
                            data => {
                                console.log(data);
                                this.submitCheck = true;
                            }
                        );
                }

                LoaderUtils.showLoader("contact-form-loader");

                // else submit contact form
                this.apiUtils.saveDevis();
            } else {
                Utils.checkFormControlsValidity(e.form);
            }
        }
        this.isAutocompleteEvent = false;
    }

    // sleep time expects milliseconds
    public sleep (time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }




    // Jamais utilisées.
    // public ajaxLocality(locality)
    // {
    //     const capaddressurl = this.api_configurateur_url + "/api/capadresse?locality=" + locality;
    //     this.apiRequest(capaddressurl, (data) => console.log("ajaxLocality", data));
    // }

    // public ajaxCompanyName(locality, societe) {
    //     const capaddressurl = this.api_configurateur_url + "/api/capadresse?locality=" + locality + "&societe=" + societe;
    //     this.apiRequest(capaddressurl, (data) => console.log("ajaxLocality", data));
    // }

    private getCompanyInformation(pSiret: string): void {
        let capaddressurl: string = this.api_configurateur_url + "/api/capadresse?siret=" + pSiret;
        this.apiUtils.apiRequest(capaddressurl, (data) => this.CapAdresseAutocompleteFormCallback(data));

        capaddressurl = this.api_configurateur_url + "/api/capadresse?namemore=" + pSiret;
        this.apiUtils.apiRequest(capaddressurl, (data) => this.CapAdresseAutocompleteFormCallback(data));
    }



    public CapAdresseAutocompleteFormCallback(json) {

        console.log(this.TAG, "CapAdresseAutocompleteFormCallback()", json.response);
        // If wrong response, stop autocomplete
        if ((json.response === "GetSctData" && json.iRet !== 0) || (json.response === "GetAdditionalData" && json.iRet !== 0)) {
            return;
        }

        if(json.response === "GetSctData") {
            const results = json.Siret[0];

            // Autocomplete with form element machine name
            for (const key in this.mappingCapadresse) {
                let value = "";
                if (results.hasOwnProperty(key)) {
                    value = results[key];

                    // Exception for each date form element
                    if (key === "sDCRET") {
                        value = value.substr(0, 4) + "-" + value.substr(4, 2) + "-" + value.substr(6, 2);
                    }

                    // Exception SIRET. SIRET = SIREN+NIC
                    if (key === "sSIREN") {
                        value += results["sNIC"];
                    }

                    if(key === "sL7_ETRG") {
                        value = "FR";//value.charAt(0).toUpperCase() + value.substr(1).toLowerCase();
                    }

                    if(key === "sTEFEN" || key === "sTEFET") {
                        let idEffectif = {
                            "00": "0 salarié",
                            "01": "1 ou 2 salariés",
                            "02": "3 à 5 salariés",
                            "03": "6 à 9 salariés",
                            "11": "10 à 19 salariés",
                            "12": "20 à 49 salariés",
                            "21": "50 à 99 salariés",
                            "22": "100 à 199 salariés",
                            "31": "200 à 249 salariés",
                            "32": "250 à 499 salariés",
                            "41": "500 à 999 salariés",
                            "42": "1000 à 1999 salariés",
                            "51": "2000 à 4999 salariés",
                            "52": "5000 à 9999 salariés",
                            "53": "10000 salariés et plus"
                        };

                        value = idEffectif[value];
                    }
                }

                this.valuesDictionary[this.mappingCapadresse[key]] = value;
            }
        }
    }

    ngAfterViewInit(): void
    {
        LoaderUtils.addLoader("contact-form-loader", <HTMLElement>this.el.nativeElement, false);
    }

    public desactivateNavigatorAutocomplete() {
        let value = "off";

        if(/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())) {
            value = "false";
        }

        return value;
    }
}



// WEBPACK FOOTER //
// ./src/app/main-view/contact-form/contact-form.component.ts